import { ROUTES } from '../routes';

export type NextLinkHref =
  | string
  | {
      pathname?: string;
      query?: Record<string, string | string[] | undefined>;
      hash?: string;
    };

export interface FeatureBannerProps {
  title: string;
  description: string;
  buttonText: string;
  href: NextLinkHref;
}

export const FEATURE_BANNERS: FeatureBannerProps[] = [
  {
    title: 'Get instant property estimate',
    description: 'Find out what your home is worth in seconds',
    buttonText: 'Get estimate',
    href: ROUTES.UNAUTHENTICATED.GET_ESTIMATES,
  },
  {
    title: 'List my property',
    description: 'Be online in as little as 20 minutes',
    buttonText: 'List your Property',
    href: ROUTES.UNAUTHENTICATED.CREATE_LISTING,
  },
];

interface DashboardBannerCopy {
  title: string;
  description: string;
  buttonText: string;
}

export interface DashboardBannerProps extends DashboardBannerCopy {
  id: 'valuation' | 'list-property' | 'pre-sale-advisor' | 'free-consultation';
  compact: DashboardBannerCopy;
  linkLabel?: string;
  href?: string;
  url?: string;
}

export const DASHBOARD_BANNERS: DashboardBannerProps[] = [
  {
    id: 'valuation',
    title: 'Get Property Valuation',
    description: 'Find out what your property is worth.',
    buttonText: 'Get Estimation',
    compact: {
      title: 'Get my valuation',
      description: 'What your property is worth, from comparable sales.',
      buttonText: 'See my valuation',
    },
    href: ROUTES.UNAUTHENTICATED.GET_ESTIMATES,
  },
  {
    id: 'list-property',
    title: 'List my property for sale',
    description: 'Just minimal details and list your property for sale',
    buttonText: 'List your Property',
    compact: {
      title: 'List my property',
      description: 'Minimal details to start. You can save and come back.',
      buttonText: 'Start my listing',
    },
    href: ROUTES.UNAUTHENTICATED.CREATE_LISTING,
  },
  {
    id: 'pre-sale-advisor',
    title: 'Pre-Sale Advisor',
    description:
      'Get your home ready before you list. Repairs, styling and timing.',
    buttonText: 'Start my plan',
    compact: {
      title: 'Pre-sale advisor',
      description: 'Repairs, styling and timing before you list.',
      buttonText: 'Start my plan',
    },
    linkLabel: 'unreservedrealestate.com.au/prepare',
    url: 'https://www.unreservedrealestate.com.au/prepare',
  },
  {
    id: 'free-consultation',
    title: 'Book a free consultation',
    description:
      'Talk to our licensed team about your price, your campaign and what it should cost.',
    buttonText: 'Book a time',
    compact: {
      title: 'Book a free consultation',
      description: 'Talk to our licensed team about price and campaign.',
      buttonText: 'Book a time',
    },
    linkLabel: 'calendly.com/ben-unreservedrealestate',
    url: 'https://calendly.com/ben-unreservedrealestate',
  },
];

export const UNRESERVED_LISTINGS_LINK = {
  label: 'Unreserved listings',
  url: 'https://www.unreservedrealestate.com.au/for-sale-by-owner/listings/',
} as const;

export const ENQUIRED_PROPERTIES_EMPTY_STEPS = [
  {
    title: 'Browse the portals',
    description:
      'Properties you enquire on from realestate.com.au and domain.com appear here.',
  },
  {
    title: 'Track every enquiry',
    description:
      'Inspection times, documents and vendor responses stay in one place.',
  },
  {
    title: 'Move to an offer',
    description:
      'When you are ready, your offer and contract sit alongside the listing.',
  },
] as const;
